import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import useStyles from './TableItem.style';
import {Fonts} from '../../../../shared/constants/AppEnums';
import {CartItems} from '../../../../types/models/ecommerce/EcommerceApp';

interface CartTableProps {
  data: CartItems;
}

const CartTableItem: React.FC<CartTableProps> = ({data}) => {
  const classes = useStyles();

  return (
    <TableRow key={data.ProductCode}>
      <TableCell>
        <Box display='flex'>
          <Box mr={2} clone>
            <Avatar src={data.ImageUrl} variant='rounded' />
          </Box>
          <Box pt={2.5}>
            <Box fontSize={14} fontWeight={Fonts.MEDIUM}>
              {data.Description}
            </Box>
          </Box>
        </Box>
      </TableCell>
      <TableCell align='left' className={classes.tableCell}>
        RM{data.SalesAmount.toFixed(2)} x {data.count}
      </TableCell>

      <TableCell align='right' className={classes.tableCell}>
        RM{(data.SalesAmount * +data.count).toFixed(2)}
      </TableCell>
    </TableRow>
  );
};

export default CartTableItem;
